export default "__VITE_ASSET__BZpU9c$W__"